import React from 'react';
import NewTerms from './NewTerms';
import {RedirectWithParams} from 'epic-diesel-common';
import {useSelector} from 'react-redux';
import {selectAffiliate, selectEnableMigration} from '../../selectors';
import {canMigrate} from '../../../shared/utils/ValidationUtils';

const NewTermsView = props => {
    const affiliate = useSelector(selectAffiliate);
    const enableV2Migration = useSelector(selectEnableMigration);

    if (!enableV2Migration || !canMigrate(affiliate)) {
        return <RedirectWithParams to="overview" ignoreSearch />;
    }

    return <NewTerms affiliate={affiliate} />;
};

export default NewTermsView;
